import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-297f8dda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"footer__links\" data-v-297f8dda><a href=\"https://www.schularena.com/support\" class=\"footer__link\" target=\"_blank\" data-v-297f8dda> Support </a><a href=\"https://www.schularena.com/start/faq/recarena\" class=\"footer__link\" target=\"_blank\" data-v-297f8dda> FAQ </a><a href=\"https://www.schularena.com/start/datenschutzerklaerung\" class=\"footer__link\" target=\"_blank\" data-v-297f8dda> Datenschutzerklärung </a><a href=\"https://www.schularena.com/agb\" class=\"footer__link\" target=\"_blank\" data-v-297f8dda> AGB </a></div>", 1)
const _hoisted_3 = { class: "footer__copy" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.abalir.ch/",
  target: "_blank"
}, "ABALIR AG", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(" recarena – ein Webtool von © " + _toDisplayString(_ctx.year) + " ", 1),
      _hoisted_4
    ])
  ]))
}